if (!customElements.get('vayndo-navigation')) {
  customElements.define('vayndo-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      if (!details || !summary) return;
      const close = (restoreFocus = false) => {
        if (!details.open) return;
        details.open = false;
        if (restoreFocus) summary.focus();
      };
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          close(true);
        }
      }, options);
      this.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) close();
      }, options);
      document.addEventListener('focusin', (event) => {
        if (!this.contains(event.target)) close();
      }, options);
      window.matchMedia('(min-width: 800px)').addEventListener('change', (event) => {
        if (event.matches) close();
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#cart-icon-bubble')) {
    document.querySelector('cart-drawer')?.setHeaderCartIconAccessibility?.();
  }
});
